module.exports = __webpack_public_path__ + "2e12bff83b3f35e79d6d7dfd46099aed.png";